<div class="f-modal" *ngIf="activeModal" [@down]>
    <div #mbody class="m-body" [class.xs]="size == 'xs'" [class.sm]="size == 'sm'" [class.md]="size == 'md'" [class.lg]="size == 'lg'" >
      <div class="row">
        <div class="col-xs-12 text-right">
          <button type="button" class="f-button--link btn-ico" (click)="hide()" *ngIf="showCloseButton">
            <span class="atram-ico ico-close ico-hover"></span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <img class="atram-logo" src="/assets/images/atram_614x130.png"/>
        </div>
        <div class="col-xs-12 text-center">
          <!-- <img [src]="(spSiteFolterPath ? spSiteFolterPath : '') +  status" alt="custom" class="img" *ngIf="status != 'info' && status != 'warning' && status != 'error' && status != 'success'" /> -->
          <img [src]="'../../assets/images/icon-notification-info.svg'" alt="info" class="img" *ngIf="status == 'info'" />
          <img [src]="'../../assets/images/icon-notification-warning.svg'" alt="warning" class="img" *ngIf="status == 'warning'" />
          <img [src]="'../../assets/images/icon-error.svg'" alt="error" class="img" *ngIf="status == 'error'" />
          <img [src]="'../../assets/images/icon-notification-error-upload.svg'" alt="error" class="img" *ngIf="status == 'error-upload'" />
          <img [src]="'../../assets/images/icon-notification-confirm.svg'" alt="success" class="img" *ngIf="status == 'success'" />
          <img [src]="'../../assets/images/icon-notification-success-upload.svg'" alt="success" class="img" *ngIf="status == 'success-upload'" />
          <img [src]="'../../assets/images/icon-notification-password.svg'" alt="success" class="img" *ngIf="status == 'password'" />
          <img [src]="'../../assets/images/icon-logout-new.svg'" alt="logout" class="img" *ngIf="status == 'logout'" />
          <h1 class="header-text">{{ headerText }}</h1>
          <p class="body-text" [class.pre]="bodyText.includes('{') && bodyText.includes('}')" *ngIf="!bodyText.includes('{') && !bodyText.includes('}')" [innerHTML]="bodyText"></p>
          <textarea rows="5" [value]="bodyText" *ngIf="bodyText.includes('{') && bodyText.includes('}')" disabled></textarea>
          <ng-container *ngIf="hasInputText">
            <div [class.error]="isInputTextError" class="f-form_input">
              <input type="text"
                     [formControl]="inputText"
                     [id]="inputText"
                     [name]="inputText"
                     [attr.placeholder]="inputTextPlaceholder"
                     [attr.required]="isInputTextRequired ? '' : null" />
              <label class="label" [for]="inputText" [innerHTML]="inputTextLabel" *ngIf="inputTextLabel"></label>
            </div>
            <br />
          </ng-container>
        </div>
      </div>
      <div class="row" [class.buttons-inline]="showButtonsInline">
        <div class="col-xs-12 text-center">
          <button type="button" class="f-button--primary" (click)="onClickOk($event)">
            {{ okButtonText }}
          </button>
        </div>
        <div class="col-xs-12 text-center" *ngIf="showCancelButton">
          <button type="button" class="f-button--secondary" (click)="onClickCancel($event)">
            {{ cancelButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
  